import { locale as en } from './en';
import { locale as zhHans } from './zh-Hans';
import { locale as zhHant } from './zh-Hant';

export const locales = [ en, zhHans, zhHant];
